import {
  Backdrop, Box, Button, CircularProgress, Container, Divider, FormControl,
  Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableContainer,
  TableHead, TableRow, Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { StyledTableCell, tableStyle } from "../Pays/Pays";
import axios, { AxiosInstance } from "axios";
import { useContext, useEffect, useState } from "react";
import { urlApi } from "../Pays/RowPays";
import Cookies from "universal-cookie";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import TauxDechangeForm from "../../../forms/TauxDechange/TauxDechangeForm";
import { DeviseInterface } from "../Article/InterfaceArticle";
import { AllMounth } from "../../../../constants/Constants";
import TauxExchangeRow from "./TauxExchangeRow";
import { AlertType } from "../../../../types/AlertType";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

export interface DataTaux {
  id: number;
  rate_euro: string;
  devise_id: number;
};

export interface TauxExchangeDatas {
  tableHeaders: string[];
  tableBody: DataTaux[][];
}

const dataYears = [
  new Date().getFullYear() - 1,
  new Date().getFullYear(),
  new Date().getFullYear() + 1,
];

const TauxDechange = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const [loader, setLoader] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);

  const [yearSelected, setYearSelected] = useState<number>(new Date().getFullYear());

  const [allDevise, setAllDevise] = useState<DeviseInterface[]>([]);
  const [exchangeTauxDatas, setExchangeTauxDatas] = useState<TauxExchangeDatas | undefined>(undefined);

  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [alertMessage, setAlerteMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<AlertType>("success");

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    setLoader(true);

    http.post('taux-exchange/list', { year: yearSelected })
      .then((res) => {
        setExchangeTauxDatas(res.data);
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoader(false);
      });
  }, [yearSelected, refresh]);

  useEffect(() => {
    http
      .get(`getalldevise`)
      .then((res) => {
        Array.isArray(res.data) && setAllDevise(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleReload = () => {
    setRefresh(!refresh);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false)
  }

  const stackAlert: JSX.Element = SnackBarAlert(openSnack, handleCloseAlert, alertType, alertMessage);

  return (
    <>
      <Container maxWidth="lg">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={4} sm={10} md={10}>
                <Button
                  variant="contained"
                  color="warning"
                  startIcon={<AddIcon />}
                  onClick={(e) => {
                    setOpenModal(true);
                  }}
                  sx={{ textTransform: "none", marginBottom: { xs: 2 } }}
                >
                  Ajouter
                </Button>
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    htmlFor="pays"
                    color="warning"
                    sx={{ color: "#fff", marginTop: -0.5 }}
                  >
                    Année
                  </InputLabel>
                  <Select
                    id="year"
                    native
                    color="warning"
                    sx={{ background: "#fff" }}
                    size="small"
                    value={yearSelected}
                    onChange={(e) => setYearSelected(e.target.value as number)}
                    label="year"
                    inputProps={{
                      name: "year",
                    }}
                  >
                    <option value={0}></option>
                    {dataYears.map((y) => (
                      <option value={y}>{y}</option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {
              !loader && (
                <TableContainer
                  component={Paper}
                  style={tableStyle}
                  sx={{
                    marginTop: 2,
                    marginBottom: 6
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell />
                        {exchangeTauxDatas?.tableHeaders?.map(header => (
                          <StyledTableCell key={header}>
                            {header}
                          </StyledTableCell>
                        ))}
                        <StyledTableCell>
                          Actions
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {AllMounth.map((elem, index) => (
                        <TauxExchangeRow
                          key={elem?.id}
                          isDesktopOrLaptop={isDesktopOrLaptop}
                          headers={exchangeTauxDatas?.tableHeaders as string[]}
                          oneMonthData={exchangeTauxDatas?.tableBody[index]!}
                          month={index + 1}
                          year={yearSelected}
                          allDevise={allDevise}
                          expanded={expanded}
                          setExpanded={setExpanded}
                          handleReload={handleReload}
                          setOpenSnack={setOpenSnack}
                          setAlerteMessage={setAlerteMessage}
                          setAlertType={setAlertType}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Button
                variant="contained"
                size='small'
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{ textTransform: "none" }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>

              <FormControl sx={{ mt: 2 }} fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  color="warning"
                  sx={{ mt: -1 }}
                >
                  Année
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  sx={{ background: "#fff", mb: 3 }}
                  size="small"
                  color="warning"
                  label="Année"
                  value={yearSelected}
                  onChange={(e) => setYearSelected(e.target.value as number)}
                >
                  <MenuItem value="" dense></MenuItem>
                  {dataYears.map((item) => (
                    <MenuItem key={item} value={item} dense>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Typography>Liste Taux de Change</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 3 }} />
            </Box>

            <Box mt='10rem'>
              {AllMounth.map((elem, index) => (
                <TauxExchangeRow
                  key={elem?.id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  headers={exchangeTauxDatas?.tableHeaders as string[]}
                  oneMonthData={exchangeTauxDatas?.tableBody[index]!}
                  month={index + 1}
                  year={yearSelected}
                  allDevise={allDevise}
                  expanded={expanded}
                  setExpanded={setExpanded}
                  handleReload={handleReload}
                  setOpenSnack={setOpenSnack}
                  setAlerteMessage={setAlerteMessage}
                  setAlertType={setAlertType}
                />
              ))}
            </Box>
          </>
        )}
      </Container>

      <OptionalWidthModal
        title="Ajouter un nouveau Taux d'echange"
        breackPoint="md"
        onClose={handleClose}
        open={openModal}
      >
        <TauxDechangeForm
          allDevise={allDevise}
          handleReload={handleReload}
          onClose={handleClose}
        />
      </OptionalWidthModal>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      {stackAlert}
    </>
  );
};

export default TauxDechange;
